/* eslint-disable no-unused-expressions */
/* eslint-disable no-undef */

// 260812 Windows(Pentalk Browser) 학생 앱 통지용. onExitButtonClick() 참고.
import { sendToStudentApp } from "../func/ExportFunction";

/**
 * 안드로이드 Pro용 앱의 웹뷰인지 여부를 반환
 * 
 * @returns {Boolean} 안드로이드 Pro용 앱 웹뷰인지 여부
 * @since 2025-12-05.
 */
const isPentalkAndr = () => {
    let _isPentalkAndr = typeof window.ProcessComm !== "undefined";
    // console.log("_isPentalkAndr - [", _isPentalkAndr, "]");
    return _isPentalkAndr;
}

// 전역 메서드 처리
window.isPentalkAndr = isPentalkAndr;

/**
 * 안드로이드 Pro용 앱의 웹뷰에서 MediaSoupComm을 지원하는지 여부를 반환합니다.
 * 
 * @returns {Boolean} 안드로이드 Pro용 앱의 웹뷰에서 MediaSoupComm을 지원하는지 여부
 * @since 2026-02-11.
 */
const hasMediaSoupComm = () => {
    let _hasMediaSoupComm = typeof window.MediaSoupComm !== "undefined";
    // console.log("_hasMediaSoupComm - [", _hasMediaSoupComm, "]");
    return _hasMediaSoupComm;
}

// 전역 메서드 처리
window.hasMediaSoupComm = hasMediaSoupComm;

/**
 * 웹 카메라 Producer 상태를 Android 통합 캡처 상태로 전달합니다.
 *
 * @param {Object} stateInfo 카메라 송출 상태 정보
 * @since 2026-07-31.
 */
function callCaptureStateChanged(stateInfo) {
    if (!isPentalkAndr() || typeof window.ProcessComm.updateCaptureState !== "function") return;

    window.ProcessComm.updateCaptureState(JSON.stringify(stateInfo));
}

// 260731 MediaSoupClient에서 카메라 송출 상태 전달에 사용한다.
window.callCaptureStateChanged = callCaptureStateChanged;

/**
 * 웹 카메라 outbound RTP 통계를 Android에 전달합니다.
 *
 * @param {Object} statsInfo 실제 송출 해상도 및 FPS 정보
 * @since 2026-07-31.
 */
function callCaptureStatsUpdated(statsInfo) {
    if (!isPentalkAndr() || typeof window.ProcessComm.updateCaptureStats !== "function") return;

    window.ProcessComm.updateCaptureStats(JSON.stringify(statsInfo));
}

// 260731 MediaSoupClient에서 실제 카메라 송출 통계 전달에 사용한다.
window.callCaptureStatsUpdated = callCaptureStatsUpdated;

/**
 * ========================================
 * JavaScript - 전체 화면 모드 명령어 호출
 * ProcessComm을 통한 Android Native 메서드 호출
 * ========================================
 */

/**
 * 로그인 알림을 WebView앱에 전달합니다.
 * 
 * @since 2025-12-29.
 */
function callLogin() {
    if (!isPentalkAndr()) {
        return;
    }

    if (window.ProcessComm.callLogin) {
        console.log("window.ProcessComm.callLogin() 호출");
        window.ProcessComm.callLogin();
    }
}

// 전역 메서드 처리
window.callLogin = callLogin;

/**
 * 로그인 응답 알림을 WebView앱에 전달합니다.
 * 
 * @since 2025-12-29.
 */
function callLoginResp(status) {
    if (!isPentalkAndr()) {
        return;
    }

    if (window.ProcessComm.callLoginResp) {
        console.log("window.ProcessComm.callLoginResp(status) 호출");
        window.ProcessComm.callLoginResp(status);
    }
}

// 전역 메서드 처리
window.callLoginResp = callLoginResp;

/**
 * 로그아웃 알림을 WebView앱에 전달합니다.
 * 
 * @since 2025-12-29.
 */
function callLogout() {
    if (!isPentalkAndr()) {
        return;
    }

    if (window.ProcessComm.callLogout) {
        console.log("window.ProcessComm.callLogout() 호출");
        window.ProcessComm.callLogout();
    }
}

// 전역 메서드 처리
window.callLogout = callLogout;

/**
 * 로그아웃 응답 알림을 WebView앱에 전달합니다.
 * 
 * @since 2025-12-29.
 */
function callLogoutResp() {
    if (!isPentalkAndr()) {
        return;
    }

    if (window.ProcessComm.callLogoutResp) {
        console.log("window.ProcessComm.callLogoutResp() 호출");
        window.ProcessComm.callLogoutResp();
    }
}

// 전역 메서드 처리
window.callLogoutResp = callLogoutResp;

/**
 * 로그아웃 응답 알림을 WebView앱에 전달합니다.
 * 
 * @since 2025-12-29.
 */
function callSmartTVResponse() {
    if (!isPentalkAndr()) {
        return;
    }

    if (window.ProcessComm.callSmartTVResponse) {
        console.log("window.ProcessComm.callSmartTVResponse 호출");
        window.ProcessComm.callSmartTVResponse();
    }
}

// 전역 메서드 처리
window.callSmartTVResponse = callSmartTVResponse;

/**
 * LG 스마트TV와 인터넷 속도를 고려한 맞춤 프레임 속도 값을 선생님에게 전송받아서
 * 설정하는 메서드.
 *  
 * @param {Number} lSeq - 클래스 시퀀스 번호
 * @param {String} configFPS - 프레임
 * @since 2026-06-08.
 */
function callNetImageFrames(configFPS) {
    if (!isPentalkAndr()) {
        return;
    }

    if (window.ProcessComm.callNetImageFrames) {
        console.log("window.ProcessComm.callNetImageFrames(configFPS: " + configFPS + ") 호출");
        window.ProcessComm.callNetImageFrames(configFPS);
    }
}

// 전역 메서드 처리
window.callNetImageFrames = callNetImageFrames;

/**
 * 클래스 멤버 목록이 준비되었음을 WebView앱에 전달합니다.
 * 
 * @since 2026-03-09.
 */
function callClassMemberListReady() {
    if (!isPentalkAndr()) {
        return;
    }

    if (window.ProcessComm.callClassMemberListReady) {
        console.log("window.ProcessComm.callClassMemberListReady 호출");
        window.ProcessComm.callClassMemberListReady();
    }
}

// 전역 메서드 처리
window.callClassMemberListReady = callClassMemberListReady;

/**
 * 믹스드 클래스 멤버 목록이 준비되었음을 WebView앱에 전달합니다.
 * 
 * @since 2026-01-13.
 */
function callMixedClassMemberListReady() {
    if (!isPentalkAndr()) {
        return;
    }

    if (window.ProcessComm.callMixedClassMemberListReady) {
        console.log("window.ProcessComm.callMixedClassMemberListReady 호출");
        window.ProcessComm.callMixedClassMemberListReady();
    }
}

// 전역 메서드 처리
window.callMixedClassMemberListReady = callMixedClassMemberListReady;

// ========================================
// 1. 화면 캡처 시작
// ========================================

/**
 * 화면 캡처를 시작합니다.
 * 
 * @param {Object} options - 캡처 옵션
 * @param {boolean} options.isP2PMode - P2P 모드 여부
 * @param {boolean} options.isHandsUpInit - HandsUp 초기화 여부
 * @param {string} options.configFPSKind - FPS 설정
 * @since 2025-12-22.
 */
function startScreenCapture(options = {}) {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.ProcessComm.startScreenCapture === "function") {
        console.log("📱 startScreenCapture 호출", options);

        // ⭐ 수정: localStreamingMode 추가
        const captureInfo = {
            isP2PMode: options.isP2PMode || false,
            isHandsUpInit: options.isHandsUpInit || false,
            configFPSKind: options.configFPSKind || "default",
            localStreamingMode: options.localStreamingMode || 0,  // ⭐ 추가!
            isForSmartPen: options.isForSmartPen || false,         // ⭐ 추가 (혹시 필요할 수 있음)
            isReconnMode: options.isReconnMode || false            // ⭐ 추가 (혹시 필요할 수 있음)
        };

        console.log("====================================================");
        console.log("📤 Native로 전달할 captureInfo:");
        console.log("  isP2PMode:", captureInfo.isP2PMode);
        console.log("  localStreamingMode:", captureInfo.localStreamingMode);
        console.log("  configFPSKind:", captureInfo.configFPSKind);
        console.log("  isHandsUpInit:", captureInfo.isHandsUpInit);
        console.log("====================================================");

        window.ProcessComm.startScreenCapture(JSON.stringify(captureInfo));
    }
}

// 전역 메서드 처리
window.startScreenCapture = startScreenCapture;

// ========================================
// 2. 화면 캡처 중지
// ========================================

/**
 * 화면 캡처를 중지합니다.
 * 
 * @since 2025-12-22.
 */
function stopScreenCapture() {
    if (!isPentalkAndr()) {
        return;
    }

    if (window.ProcessComm.stopScreenCapture) {
        console.log("🛑 window.ProcessComm.stopScreenCapture 호출");
        window.ProcessComm.stopScreenCapture();
    }
}

// 전역 메서드 처리
window.stopScreenCapture = stopScreenCapture;

// ========================================
// 3. Thumbnail 보기 / 전체보기 (ct_StopP2P)
// ========================================

/**
 * Thumbnail 보기 / 전체보기로 전환합니다.
 * 
 * @since 2025-12-22.
 */
function setThumbnailMode() {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.setThumbnailMode) {
        console.log("🖼️ window.ProcessComm.setThumbnailMode 호출 (Thumbnail 보기)");
        window.ProcessComm.setThumbnailMode();
    }
}

// 전역 메서드 처리
window.setThumbnailMode = setThumbnailMode;

// ========================================
// 4. 1명 보기 (P1P)
// ========================================

/**
 * 1명 보기 모드로 전환합니다.
 * 
 * @since 2025-12-22.
 */
function setP1PMode() {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.setP1PMode) {
        console.log("👤 window.ProcessComm.setP1PMode 호출 (1명 보기)");
        window.ProcessComm.setP1PMode();
    }
}

// 전역 메서드 처리
window.setP1PMode = setP1PMode;

// ========================================
// 5. 2명 보기 (P2P)
// ========================================

/**
 * 2명 보기 모드로 전환합니다.
 * 
 * @since 2025-12-22.
 */
function setP2PMode() {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.setP2PMode) {
        console.log("👥 window.ProcessComm.setP2PMode 호출 (2명 보기)");
        window.ProcessComm.setP2PMode();
    }
}

// 전역 메서드 처리
window.setP2PMode = setP2PMode;

// ========================================
// 6. 4명 보기 (P4P)
// ========================================

/**
 * 4명 보기 모드로 전환합니다.
 * 
 * @since 2025-12-22.
 */
function setP4PMode() {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.setP4PMode) {
        console.log("👨‍👩‍👧‍👦 window.ProcessComm.setP4PMode 호출 (4명 보기)");
        window.ProcessComm.setP4PMode();
    }
}

// 전역 메서드 처리
window.setP4PMode = setP4PMode;

/**
 * 현재 화면 캡처 및 이미지 전송 요청을 WebView앱에 전달합니다.
 * 
 * @since 2025-12-24.
 */
function requestPageArtifact() {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.requestPageArtifact) {
        console.log("window.ProcessComm.requestPageArtifact()");
        window.ProcessComm.requestPageArtifact();
        console.log("현재 화면 캡처 및 이미지 전송 요청 전송");
    }
}

// 전역 메서드 처리
window.requestPageArtifact = requestPageArtifact;

// ========================================
// 터치 제어 관련
// ========================================

/**
 * 화면 잠금 명령을 WebView앱에 전달합니다.
 * 
 * @since 2025-12-24.
 */
function lockTouchScreen() {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.lockTouchScreen) {
        console.log("window.ProcessComm.lockTouchScreen()");
        window.ProcessComm.lockTouchScreen();
        console.log("화면 잠금 요청 전송");
    }
}

// 전역 메서드 처리
window.lockTouchScreen = lockTouchScreen;

/**
 * 화면 잠금 해제 명령을 WebView앱에 전달합니다.
 * 
 * @since 2025-12-24.
 */
function unLockTouchScreen() {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.unLockTouchScreen) {
        console.log("window.ProcessComm.unLockTouchScreen()");
        window.ProcessComm.unLockTouchScreen();
        console.log("화면 잠금 해제 요청 전송");
    }
}

// 전역 메서드 처리
window.unLockTouchScreen = unLockTouchScreen;

// ========================================
// 원격 제어 관련
// ========================================

/**
 * 웹뷰에 원격 제어 권한을 요청합니다.
 * 
 * @since 2026-02-09.
 */
function callRemoteControlStartPermCheck(permissionRequestId = "", timeoutMs = 0) {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.callRemoteControlStartPermCheck) {
        // 20260807 신규 앱에는 권한 요청 식별값을 전달하고 구버전 앱은 기존 메서드로 처리한다.
        if (window.ProcessComm.callRemoteControlStartPermCheckWithRequest) {
            window.ProcessComm.callRemoteControlStartPermCheckWithRequest(String(permissionRequestId || ""), Number(timeoutMs) || 0);
        } else {
            window.ProcessComm.callRemoteControlStartPermCheck();
        }
        console.log("원격 제어 권한 요청 전송");
    }
}

// 전역 메서드 처리
window.callRemoteControlStartPermCheck = callRemoteControlStartPermCheck;

/**
 * 요청 ID가 일치하는 원격 제어 권한 화면을 취소합니다.
 *
 * @since 2026-08-07.
 */
function callRemoteControlPermissionCancel(permissionRequestId = "", reason = "") {
    if (!isPentalkAndr()) return;
    // 20260807 취소 브리지를 지원하는 신규 앱에서만 만료된 요청을 종료한다.
    if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.callPermissionRequestCancel) {
        window.ProcessComm.callPermissionRequestCancel("remoteControl", String(permissionRequestId || ""), String(reason || ""));
    }
}

window.callRemoteControlPermissionCancel = callRemoteControlPermissionCancel;

/**
 * 웹뷰에 원격 제어 종료 요청을 전달합니다.
 * 
 * @since 2026-02-09.
 */
function callRemoteControlEnd() {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.callRemoteControlEnd) {
        console.log("window.ProcessComm.callRemoteControlEnd()");
        window.ProcessComm.callRemoteControlEnd();
        console.log("원격 제어 종료 요청 전송");
    }
}

// 전역 메서드 처리
window.callRemoteControlEnd = callRemoteControlEnd;

/**
 * 웹뷰에 원격 제어 좌표 정보 객체 전체를 전달합니다.
 * 내부에서 구형 앱과의 호환을 위해 기존 좌표 정보만을 전달하는 메서드 호출을 분기 처리하였습니다.
 * 
 * - information = { positionArray, width, height, startTimeStamp, endTimeStamp, isDown, isUp, ... };
 * #param {Array} positionArray - 원격 제어 좌표 정보 배열
 * #param {Number} width - 화면 너비 (선생님 화면)
 * #param {Number} height - 화면 높이 (선생님 화면)
 * #param {Number} startTimeStamp - 좌표 시작 시간(Down)
 * #param {Number} endTimeStamp - 좌표 종료 시간(Up)
 * #param {Boolean} isDown - Down 좌표인지 여부
 * #param {Boolean} isUp - Up 좌표인지 여부
 * @param {Object} information - 원격 제어 좌표와 확장 정보를 포함한 객체
 * @since 2026-02-09. (@modify 2026-09-04.)
 */
function callRemoteControlPositionInfo(information) {
    if (!isPentalkAndr() || !information) {
        return;
    }

    // 20260904 신규 앱에서는 callRemoteControlPositionInfoData()를 사용하고, 구형 앱은 기존 callRemoteControlPositionInfo()를 사용한다.
    if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.callRemoteControlPositionInfoData) {
        console.log("window.ProcessComm.callRemoteControlPositionInfoData()");
        window.ProcessComm.callRemoteControlPositionInfoData(JSON.stringify(information));
        console.log("원격 제어 좌표 정보 전체 전송");
    } else {
        if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.callRemoteControlPositionInfo) {
            console.log("window.ProcessComm.callRemoteControlPositionInfo()");

            // 20260904 표준 startTimeStamp/endTimeStamp를 우선 사용하고, 과거 전송의 startTimeStap/endTimeStap도 대체 값으로 수용한다.
            const {
                positionArray,
                width,
                height,
                startTimeStamp = information.startTimeStap,
                endTimeStamp = information.endTimeStap,
            } = information;

            // 20260904 구형 Pro 브리지에도 전달할 좌표 배열 JSON 문자열입니다.
            const pointsArrayStr = JSON.stringify(positionArray);

            // 20260904 구형 Pro 앱은 5개 인자 브리지만 제공하므로 오늘 추가한 isDown/isUp은 전달하지 않는다.
            window.ProcessComm.callRemoteControlPositionInfo(pointsArrayStr, width, height, startTimeStamp, endTimeStamp);
            console.log("원격 제어 좌표 정보 전송");
        }
    }
}

// 전역 메서드 처리
window.callRemoteControlPositionInfo = callRemoteControlPositionInfo;

// ========================================
// 허가된 웹 사이트 목록 관련 (앱 포함)
// ========================================

/**
 * 새로운 탭으로 웹뷰를 띄울 수 있게 허용된 웹 사이트 주소 목록을
 * 웹뷰 앱으로 전달합니다.
 * 
 * #param {Array} list - 웹 사이트 주소 배열
 * @param {String} information - 웹 사이트 주소 배열 및 컨텐츠 정보 (JSON 문자열)
 * @since 2026-02-25.
 */
function callAllowWebSiteList(information) {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.WebSiteLauncher !== "undefined" && window.WebSiteLauncher.callAllowWebSiteList) {
        console.log("window.WebSiteLauncher.callAllowWebSiteList()");
        window.WebSiteLauncher.callAllowWebSiteList(information);
        console.log("접근이 허용된 웹 사이트 주소 목록 전송");
    }
}

// 전역 메서드 처리
window.callAllowWebSiteList = callAllowWebSiteList;

// ========================================
// URL 강제 실행 관련
// ========================================

/**
 * 새로운 탭에 전달받은 웹 사이트 주소의 웹뷰를 띄웁니다.
 * 
 * @param {String} url - 웹 사이트 주소
 * @since 2026-02-25. (@modify 2026-06-11.)
 */
function callStartWebSiteLoad(url) {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.WebSiteLauncher !== "undefined" && window.WebSiteLauncher.callStartWebSiteLoad) {
        console.log("window.WebSiteLauncher.callStartWebSiteLoad(url: " + url + ")");
        window.WebSiteLauncher.callStartWebSiteLoad(url);
        console.log("강제 실행 웹 사이트 주소 전송");
    }
}

// 전역 메서드 처리
window.callStartWebSiteLoad = callStartWebSiteLoad;

/**
 * 새로운 탭에 웹 사이트를 띄웁니다. (확장 정보 버전)
 * JS → Android JavascriptInterface 로 information 객체를 JSON 문자열로 전달합니다.
 *
 * @param {Object} information - { url, faviconUrl, contentSeq, contentTeacherSeq, refContentSeq, ... }
 * @since 2026-06-11.
 */
function callStartWebSiteLoadWithContentInfo(information) {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.WebSiteLauncher !== "undefined" && window.WebSiteLauncher.callStartWebSiteLoadWithContentInfo) {
        // Android 측에 JSON 문자열로 직렬화하여 전달
        // → Android에서 JSONObject.optString()으로 각 필드 파싱
        const json = (typeof information === "string") ? information : JSON.stringify(information);
        console.log("window.WebSiteLauncher.callStartWebSiteLoadWithContentInfo(json: " + json + ")");
        window.WebSiteLauncher.callStartWebSiteLoadWithContentInfo(json);
        console.log("확장 정보 포함 웹 사이트 주소 전송");
    } else {
        // 폴백: 구버전 앱은 url만 사용하는 기존 메서드 호출
        console.log("callStartWebSiteLoadWithContentInfo 미지원 → callStartWebSiteLoad 폴백");
        callStartWebSiteLoad(information.url);
    }
}

// 전역 메서드 처리
window.callStartWebSiteLoadWithContentInfo = callStartWebSiteLoadWithContentInfo;

/**
 * 전달받은 앱 정보를 사용하여 해당 앱을 실행합니다.
 * 
 * @param {Object} information - 앱 정보 (appSeq, appName, appPkgData, faviconUrl, contentSeq, contentTeacherSeq, refContentSeq ...)
 * @since 2026-06-05.
 */
function callStartApp(information) {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.WebSiteLauncher !== "undefined" && window.WebSiteLauncher.callStartApp) {
        // Android 측에 JSON 문자열로 직렬화하여 전달
        // → Android에서 JSONObject.optString()으로 각 필드 파싱
        const json = (typeof information === "string") ? information : JSON.stringify(information);
        console.log("window.WebSiteLauncher.callStartApp(json: " + json + ")");
        window.WebSiteLauncher.callStartApp(json);
        console.log("앱 강제 실행 요청 전송");
    }
}

// 전역 메서드 처리
window.callStartApp = callStartApp;

/**
 * 안드로이드 웹뷰 앱의 메인 탭으로 전환 요청을 전송합니다.
 * 
 * @since 2026-04-01.
 */
function callSwitchToMainTab() {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.WebSiteLauncher !== "undefined" && window.WebSiteLauncher.callSwitchToMainTab) {
        console.log("window.WebSiteLauncher.callSwitchToMainTab()");
        window.WebSiteLauncher.callSwitchToMainTab();
        console.log("메인 탭 표시 요청");
    }
}

// 전역 메서드 처리
window.callSwitchToMainTab = callSwitchToMainTab;

/**
 * contentSeq에 해당하는 탭으로 전환합니다.
 * 해당 탭이 이미 닫혔다면, 함께 전달된 url로 새 서브탭을 열어줍니다.
 *
 * @param {Object} information - { contentSeq, url, faviconUrl, ... }
 * @since 2026-06-11.
 */
function callSwitchToContentSeqTab(information) {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.WebSiteLauncher !== "undefined" && window.WebSiteLauncher.callSwitchToContentSeqTab) {
        const json = (typeof information === "string") ? information : JSON.stringify(information);
        console.log("window.WebSiteLauncher.callSwitchToContentSeqTab()");
        window.WebSiteLauncher.callSwitchToContentSeqTab(json);
        console.log("contentSeq 탭 전환 요청 전송");
    }
}

// 전역 메서드 처리
window.callSwitchToContentSeqTab = callSwitchToContentSeqTab;

/**
 * [신규] 'switch-main-tab' 수신 시, information.contentSeq 유무에 따라
 * callSwitchToMainTab / callSwitchToContentSeqTab 중 적절한 쪽으로
 * 자동 분기해주는 통합 디스패처 헬퍼입니다.
 *
 * - information.contentSeq 가 "존재"하는 경우
 *   → callSwitchToContentSeqTab(information) 호출
 *     (해당 contentSeq 탭으로 전환, 탭이 닫혀있으면 information.url로 새 탭 오픈)
 *
 * - information.contentSeq 가 "없는" 경우 (undefined / null / 빈 문자열)
 *   → callSwitchToMainTab() 호출
 *     (단순히 메인 탭으로 포커스 전환)
 *
 * 호출부(rcvMsgFromRbmq.js 등)에서는 분기 로직을 직접 작성할 필요 없이
 * window.callSwitchTab(information) 한 줄만 호출하면 됩니다.
 *
 * @param {Object} information - { contentSeq, url, faviconUrl, ... } (contentSeq는 생략 가능)
 * @since 2026-06-15.
 */
function callSwitchTab(information = {}) {
    if (!isPentalkAndr()) {
        return;
    }

    const { contentSeq } = information;

    // contentSeq 가 0 으로 내려오는 경우도 "유효한 값"일 수 있으므로,
    // truthy 체크(!contentSeq)가 아닌 != null + 빈 문자열 체크로 "값의 존재 여부"만 판단
    const hasContentSeq = contentSeq !== undefined && contentSeq !== null && contentSeq !== "";

    if (hasContentSeq) {
        // contentSeq가 있으면 → 해당 contentSeq 탭으로 전환 (없으면 url로 새 탭 오픈)
        console.log(`callSwitchTab - contentSeq[${contentSeq}] 존재 → callSwitchToContentSeqTab 호출`);
        callSwitchToContentSeqTab(information);
    } else {
        // contentSeq가 없으면 → 단순히 메인 탭으로 전환
        console.log("callSwitchTab - contentSeq 없음 → callSwitchToMainTab 호출");
        callSwitchToMainTab();
    }
}

// 전역 메서드 처리
window.callSwitchTab = callSwitchTab;

/**
 * 안드로이드 웹뷰 앱의 서브 탭 모두 닫기 요청을 전송합니다.
 * 
 * @since 2026-04-01.
 */
function callCloseAllSubTabs() {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.WebSiteLauncher !== "undefined" && window.WebSiteLauncher.callCloseAllSubTabs) {
        console.log("window.WebSiteLauncher.callCloseAllSubTabs()");
        window.WebSiteLauncher.callCloseAllSubTabs();
        console.log("서브 탭 모두 닫기 요청");
    }
}

// 전역 메서드 처리
window.callCloseAllSubTabs = callCloseAllSubTabs;

/**
 * contentSeq 또는 refContentSeq에 해당하는 서브 탭을 닫습니다.
 *
 * @param {Object} information - { contentSeq, refContentSeq, ... }
 * @since 2026-06-25.
 */
function callCloseContentSeqTab(information) {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.WebSiteLauncher === "undefined") {
        return;
    }

    const json = (typeof information === "string") ? information : JSON.stringify(information);

    if (window.WebSiteLauncher.callCloseContentSeqTab) {
        console.log("window.WebSiteLauncher.callCloseContentSeqTab()");
        window.WebSiteLauncher.callCloseContentSeqTab(json);
        console.log("contentSeq/refContentSeq 서브 탭 닫기 요청");
    } else if (window.WebSiteLauncher.callCloseSubTab) {
        console.log("window.WebSiteLauncher.callCloseSubTab()");
        window.WebSiteLauncher.callCloseSubTab(json);
        console.log("contentSeq/refContentSeq 서브 탭 닫기 요청");
    }
}

// 전역 메서드로 처리
window.callCloseContentSeqTab = callCloseContentSeqTab;

/**
 * 'close-sub-tab' 수신 시 contentSeq/refContentSeq 유무에 따라
 * 해당 서브 탭 또는 전체 서브 탭 닫기를 호출합니다.
 *
 * @param {Object} information - { contentSeq, refContentSeq, ... }
 * @since 2026-06-25.
 */
function callCloseSubTab(information = {}) {
    if (!isPentalkAndr()) {
        return;
    }

    const { contentSeq, refContentSeq } = information;
    const hasContentSeq = contentSeq !== undefined && contentSeq !== null && contentSeq !== "";
    const hasRefContentSeq = refContentSeq !== undefined && refContentSeq !== null && refContentSeq !== "";

    if (hasContentSeq || hasRefContentSeq) {
        console.log(`callCloseSubTab - contentSeq[${contentSeq}], refContentSeq[${refContentSeq}] 존재 → callCloseContentSeqTab 호출`);
        callCloseContentSeqTab(information);
    } else {
        console.log("callCloseSubTab - contentSeq/refContentSeq 없음 → callCloseAllSubTabs 호출");
        callCloseAllSubTabs();
    }
}

// 전역 메서드로 처리
window.callCloseSubTab = callCloseSubTab;

/**
 * 안드로이드 웹뷰 앱의 메인 탭에 알림 표시 요청을 전달합니다.
 * 
 * @since 2026-04-01.
 */
function callSetMainTabBadge() {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.WebSiteLauncher !== "undefined" && window.WebSiteLauncher.callSetMainTabBadge) {
        console.log("window.WebSiteLauncher.callSetMainTabBadge()");
        window.WebSiteLauncher.callSetMainTabBadge();
        console.log("메인 탭 알림 표시 요청");
    }
}

// 전역 메서드 처리
window.callSetMainTabBadge = callSetMainTabBadge;

/**
 * 안드로이드 웹뷰 앱의 메인 탭에 알림 표시 제거 요청을 전달합니다.
 * 
 * @since 2026-04-01.
 */
function callClearMainTabBadge() {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.WebSiteLauncher !== "undefined" && window.WebSiteLauncher.callClearMainTabBadge) {
        console.log("window.WebSiteLauncher.callClearMainTabBadge()");
        window.WebSiteLauncher.callClearMainTabBadge();
        console.log("메인 탭 알림 표시 제거 요청");
    }
}

// 전역 메서드 처리
window.callClearMainTabBadge = callClearMainTabBadge;

// ========================================
// 앱 종료 및 액션 제어 관련 (앱 포그라운드 상태 유지)
// ========================================

/**
 * 웹뷰에 앱 사용 제어 권한을 요청합니다.
 * 
 * @since 2026-02-23.
 */
function callIntensiveControlStartPermCheck(permissionRequestId = "", timeoutMs = 0) {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.callIntensiveControlStartPermCheck) {
        // 20260807 신규 앱에는 권한 요청 식별값을 전달하고 구버전 앱은 기존 메서드로 처리한다.
        if (window.ProcessComm.callIntensiveControlStartPermCheckWithRequest) {
            window.ProcessComm.callIntensiveControlStartPermCheckWithRequest(String(permissionRequestId || ""), Number(timeoutMs) || 0);
        } else {
            window.ProcessComm.callIntensiveControlStartPermCheck();
        }
        console.log("앱 사용 제어 권한 요청 전송");
    }
}

// 전역 메서드 처리
window.callIntensiveControlStartPermCheck = callIntensiveControlStartPermCheck;

/**
 * 요청 ID가 일치하는 심화 학습 권한 화면을 취소합니다.
 *
 * @since 2026-08-07.
 */
function callIntensiveControlPermissionCancel(permissionRequestId = "", reason = "") {
    if (!isPentalkAndr()) return;
    // 20260807 취소 브리지를 지원하는 신규 앱에서만 만료된 요청을 종료한다.
    if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.callPermissionRequestCancel) {
        window.ProcessComm.callPermissionRequestCancel("intensiveControl", String(permissionRequestId || ""), String(reason || ""));
    }
}

window.callIntensiveControlPermissionCancel = callIntensiveControlPermissionCancel;

/**
 * 웹뷰에 앱 사용 제어 종료 요청을 전달합니다.
 * 
 * @since 2026-02-23.
 */
function callIntensiveControlEnd() {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.callIntensiveControlEnd) {
        console.log("window.ProcessComm.callIntensiveControlEnd()");
        window.ProcessComm.callIntensiveControlEnd();
        console.log("앱 사용 제어 종료 요청 전송");
    }
}

// 전역 메서드 처리
window.callIntensiveControlEnd = callIntensiveControlEnd;

// ========================================
// ========================================

/**
 * 스몰 그룹 정보 설정 요청을 WebView앱에 전달합니다.
 * 
 * @param {String} jsonData - 스몰 그룹 정보
 * @since 2025-12-24.
 */
function setSmallGroupInfo(jsonData) {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.setSmallGroupInfo) {
        console.log("window.ProcessComm.setSmallGroupInfo()");
        window.ProcessComm.setSmallGroupInfo(jsonData);
        console.log("스몰 그룹 정보 설정 요청 전송");
    }
}

// 전역 메서드 처리
window.setSmallGroupInfo = setSmallGroupInfo;

/**
 * 현재 Produce해야할 비디오의 해상도 정보를 WebView앱에 알립니다.
 * 
 * @param {String} jsonData - 비디오 해상도 정보
 * @since 2025-12-24.
 */
function switchVideoResolution(jsonData) {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.switchVideoResolution) {
        console.log("window.ProcessComm.switchVideoResolution()");
        window.ProcessComm.switchVideoResolution(jsonData);
        console.log("비디오 해상도 정보 설정 요청 전송");
    }
}

// 전역 메서드 처리
window.switchVideoResolution = switchVideoResolution;

/**
 * 클래스에서 퇴장했음을 WebView앱에 알립니다.
 * 
 * @since 2025-12-22.
 */
function callFinishLive() {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.finishLive) {
        console.log("window.ProcessComm.finishLive()");
        window.ProcessComm.finishLive();
        console.log("클래스 종료 알림 전송");
    }
}

// 전역 메서드 처리
window.callFinishLive = callFinishLive;

/**
 * 클래스에서 시작했음을 WebView앱에 알립니다.
 * 
 * @since 2025-12-24.
 */
function callLiveOn() {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.liveOn) {
        console.log("window.ProcessComm.liveOn()");
        window.ProcessComm.liveOn();
        console.log("클래스 시작 알림 전송");
    }
}

// 전역 메서드 처리
window.callLiveOn = callLiveOn;

/**
 * 클래스가 끝났음을 WebView앱에 알립니다.
 * 
 * @since 2025-12-24.
 */
function callLiveOff() {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.callLiveOff) {
        console.log("window.ProcessComm.callLiveOff()");
        window.ProcessComm.callLiveOff();
        console.log("클래스 종료 알림 전송");
    }
}

// 전역 메서드 처리
window.callLiveOff = callLiveOff;

/**
 * 핸즈업이 시작했음을 WebView앱에 알립니다.
 * 
 * @since 2025-12-29.
 */
function callStartHandsUp() {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.startHandsUp) {
        console.log("window.ProcessComm.startHandsUp()");
        window.ProcessComm.startHandsUp();
        console.log("핸즈업 시작 알림 전송");
    }
}

// 전역 메서드 처리
window.callStartHandsUp = callStartHandsUp;

/**
 * 핸즈업이 종료되었음을 WebView앱에 알립니다.
 * 
 * @since 2025-12-29.
 */
function callStopHandsUp() {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.stopHandsUp) {
        console.log("window.ProcessComm.stopHandsUp()");
        window.ProcessComm.stopHandsUp();
        console.log("핸즈업 종료 알림 전송");
    }
}

// 전역 메서드 처리
window.callStopHandsUp = callStopHandsUp;

/**
 * 마이크/시스템 오디오 켜기 요청을 WebView앱에 전달합니다.
 * 
 * @since 2025-12-29.
 */
function callMicOn() {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.micOn) {
        console.log("window.ProcessComm.micOn()");
        window.ProcessComm.micOn();
        console.log("마이크/시스템 오디오 켜기 요청 전송");
    }
}

// 전역 메서드 처리
window.callMicOn = callMicOn;

/**
 * 마이크/시스템 오디오 끄기 요청을 WebView앱에 전달합니다.
 * 
 * @since 2025-12-29.
 */
function callMicOff() {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.micOff) {
        console.log("window.ProcessComm.micOff()");
        window.ProcessComm.micOff();
        console.log("마이크/시스템 오디오 끄기 요청 전송");
    }
}

// 전역 메서드 처리
window.callMicOff = callMicOff;

// ========================================
// MediaSoup 통신 관련
// ========================================

/**
 * Producer Transport 생성 결과를 WebView앱에 전달합니다.
 * 
 * @param {JSON} param - Producer Transport 생성 결과 정보
 * {
 *     {String} rtpCapabilities - RTP 기능 정보 (MediaSoup Device 로드에 사용),
 *     {String} id - Transport ID (서버에서 생성한 Transport의 고유 ID),
 *     {String} dtlsParameters - DTLS 파라미터 (암호화 통신 설정),
 *     {String} iceCandidates - ICE Candidate 목록 (네트워크 연결 경로 정보),
 *     {String} iceParameters - ICE 파라미터 (ICE 프로토콜 설정)
 * }
 * @since 2026-02-11.
 */
function callCreateProducerTransportAfter({ rtpCapabilities, id, dtlsParameters, iceCandidates, iceParameters }) {
    console.log("rtpCapabilities => " + rtpCapabilities);
    console.log("id => " + id);
    console.log("dtlsParameters => " + dtlsParameters);
    console.log("iceCandidates => " + iceCandidates);
    console.log("iceParameters => " + iceParameters);

    if (!hasMediaSoupComm()) {
        return;
    }

    if (typeof window.MediaSoupComm !== "undefined" && window.MediaSoupComm.callCreateProducerTransportAfter) {
        console.log("window.MediaSoupComm.callCreateProducerTransportAfter()");
        window.MediaSoupComm.callCreateProducerTransportAfter(
            rtpCapabilities,
            id,
            dtlsParameters,
            iceCandidates,
            iceParameters
        );
        console.log("Producer Transport 생성 결과 전송");
    }
}

// 전역 메서드 처리
window.callCreateProducerTransportAfter = callCreateProducerTransportAfter;

/**
 * 송출 transport ICE 재시작 응답(iceParameters)을 WebView앱에 전달합니다. 네이티브가 transport.restartIce() 를 부릅니다.
 *
 * ⚠ 브릿지가 없으면 던집니다 — 조정자가 그것을 「응답을 적용하지 못했다」로 보고 포기·재생성으로 넘어갑니다.
 *
 * @param {String} iceParametersJson - rtnVal.iceParameters 의 JSON 문자열
 * @param {String} transportId - 서버가 준 송출 transport id. 네이티브는 지금 transport 와 다르면 버립니다
 * @since 2026-09-30.
 */
function callRestartProducerTransportAfter(iceParametersJson, transportId) {
    console.log("callRestartProducerTransportAfter - transportId => " + transportId);

    if (!hasMediaSoupComm() || !window.MediaSoupComm.callRestartProducerTransportAfter) {
        throw new Error("MediaSoupComm.callRestartProducerTransportAfter 없음");
    }

    window.MediaSoupComm.callRestartProducerTransportAfter(iceParametersJson, transportId);
}

// 전역 메서드 처리
window.callRestartProducerTransportAfter = callRestartProducerTransportAfter;

/**
 * 송출 transport ICE 재시작을 포기했다고 WebView앱에 알립니다. 네이티브는 transport 만 정리하고 캡처는 유지합니다.
 * 이어서 JS 가 live_createProducerTransport 를 보내면 네이티브가 복원 생성으로 다시 produce 합니다.
 *
 * @param {String} reason - "failed-response" | "timeout" | "stale" | "settle-timeout" | "used" | "connect-timeout" (로그용)
 * @param {String} [transportId] - 서버가 준 송출 transport id. 네이티브는 지금 transport 와 다르면 버립니다.
 *                                 없으면 대조하지 않습니다(재생성 응답이 아예 안 와 지켜보던 transport 가 없을 때)
 * @since 2026-09-30.
 */
function callRestartProducerTransportFailed(reason, transportId) {
    console.log("callRestartProducerTransportFailed - reason => " + reason + ", transportId => " + transportId);

    if (!hasMediaSoupComm() || !window.MediaSoupComm.callRestartProducerTransportFailed) {
        console.log("callRestartProducerTransportFailed - MediaSoupComm 브릿지가 없다. 건너뛴다.");
        return;
    }

    // 261002 id 가 없으면 1인자 판을 부른다 — JS undefined 를 Java String 인자로 넘기면 "undefined" 문자열이 될 수 있고,
    // 그러면 네이티브가 「지금 transport 와 다르다」며 버린다. 1인자 판은 대조하지 않는다(Android 7d5c497).
    if (transportId === undefined || transportId === null) {
        window.MediaSoupComm.callRestartProducerTransportFailed(reason);
        return;
    }

    window.MediaSoupComm.callRestartProducerTransportFailed(reason, transportId);
}

// 전역 메서드 처리
window.callRestartProducerTransportFailed = callRestartProducerTransportFailed;

/**
 * Producer Transport 연결 결과를 WebView앱에 전달합니다.
 * 
 * @since 2026-02-11.
 */
function callConnectProducerTransportAfter() {
    if (!hasMediaSoupComm()) {
        return;
    }

    if (typeof window.MediaSoupComm !== "undefined" && window.MediaSoupComm.callConnectProducerTransportAfter) {
        console.log("window.MediaSoupComm.callConnectProducerTransportAfter()");
        window.MediaSoupComm.callConnectProducerTransportAfter();
        console.log("Producer Transport 연결 결과 전송");
    }
}

// 전역 메서드 처리
window.callConnectProducerTransportAfter = callConnectProducerTransportAfter;

/**
 * Producer 생성 결과를 WebView앱에 전달합니다.
 * 
 * @param {JSON} param - Producer 생성 결과 정보
 * {
 *     {String} id - Producer ID (서버에서 생성한 프로듀서(Producer)의 고유 ID),
 *     {String} mediaKind - 미디어 유형
 * }
 * @since 2026-02-11.
 */
function callProduceAfter({ id, mediaKind }) {
    if (!hasMediaSoupComm()) {
        return;
    }

    if (typeof window.MediaSoupComm !== "undefined" && window.MediaSoupComm.callProduceAfter) {
        console.log("window.MediaSoupComm.callProduceAfter(id[" + id + "], mediaKind[" + mediaKind + "])");
        window.MediaSoupComm.callProduceAfter(
            id,
            mediaKind
        );
        console.log("Producer 생성 결과 전송");
    }
}

// 전역 메서드 처리
window.callProduceAfter = callProduceAfter;

/**
 * Producer 중지 요청 결과를 WebView앱에 전달합니다.
 * 
 * @param {String} mediaKind - 미디어 유형
 * @since 2026-02-11.
 */
function callUnpublishAfter(mediaKind) {
    if (!hasMediaSoupComm()) {
        return;
    }

    if (typeof window.MediaSoupComm !== "undefined" && window.MediaSoupComm.callUnpublishAfter) {
        console.log("window.MediaSoupComm.callUnpublishAfter(mediaKind[" + mediaKind + "])");
        window.MediaSoupComm.callUnpublishAfter(mediaKind);
        console.log("Producer 중지 결과 전송");
    }
}

// 전역 메서드 처리
window.callUnpublishAfter = callUnpublishAfter;

// ========================================
// RabbitMQ 통신 관련
// ========================================

/**
 * RabbitMQ 서비스 시작 요청
 * 
 * @param {JSON} cfg - Pro 앱에 전달할 연결 정보 및 클라이언트 정보 등을 담고있는 JSON 객체
 * @since 2025-12-03.
 */
function startRabbitMQ(cfg) {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.connectRabbit) {
        console.log("window.ProcessComm.connectRabbit() 호출");
        window.ProcessComm.connectRabbit(JSON.stringify(cfg));
    }
}

// 전역 메서드 처리
window.startRabbitMQ = startRabbitMQ;

/**
 * RabbitMQ 서비스 중지 요청
 * 
 * @since 2025-12-03.
 */
function stopRabbitMQ() {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.stopRabbitMQService) {
        console.log("window.ProcessComm.stopRabbitMQService()");
        window.ProcessComm.stopRabbitMQService();
        console.log("RabbitMQ 서비스 중지 요청 전송");
    }
}

// 전역 메서드 처리
window.stopRabbitMQ = stopRabbitMQ;

/**
 * 앱용 & 웹용 구독 요청을 WebView앱에 전달합니다.
 * 
 * @since 2026-01-06.
 */
function doInitialSubscribe() {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.doInitialSubscribe) {
        console.log("window.ProcessComm.doInitialSubscribe() 호출");
        window.ProcessComm.doInitialSubscribe();
    }
}

// 전역 메서드 처리
window.doInitialSubscribe = doInitialSubscribe;

/**
 * 앱용 & 웹용 구독 해제 요청을 WebView앱에 전달합니다.
 * 
 * @since 2026-01-06.
 */
function doInitialUnsubscribe() {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.doInitialUnsubscribe) {
        console.log("window.ProcessComm.doInitialUnsubscribe() 호출");
        window.ProcessComm.doInitialUnsubscribe();
    }
}

// 전역 메서드 처리
window.doInitialUnsubscribe = doInitialUnsubscribe;

/**
 * 클래스 바인드 키 정보와 구독 요청을 WebView앱에 전달합니다.
 * 
 * @param {JSON} cfg - 클래스 연결 정보
 * @since 2025-12-30.
 */
function subscribeLive(cfg) {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.subscribeLive) {
        const keyData = JSON.stringify(cfg);
        console.log("window.ProcessComm.subscribeLive(" + keyData + ") 호출");
        window.ProcessComm.subscribeLive(keyData);
    }
}

// 전역 메서드 처리
window.subscribeLive = subscribeLive;

/**
 * 클래스 바인드 키 정보와 구독 요청을 WebView앱에 전달합니다.
 * 
 * @since 2025-12-30.
 */
function unsubscribeLive(bindKeyArr) {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.unsubscribeLive) {
        const keyData = JSON.stringify(bindKeyArr);
        console.log("window.ProcessComm.unsubscribeLive(" + keyData + ") 호출");
        window.ProcessComm.unsubscribeLive(keyData);
    }
}

// 전역 메서드 처리
window.unsubscribeLive = unsubscribeLive;

/**
 * 스몰 그룹 바인드 키 정보와 구독 요청을 WebView앱에 전달합니다.
 * 
 * @since 2025-12-30.
 */
function subscribeSmallGroup(bindKeyArr) {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.subscribeSmallGroup) {
        const keyData = JSON.stringify(bindKeyArr);
        console.log("window.ProcessComm.subscribeSmallGroup(" + keyData + ") 호출");
        window.ProcessComm.subscribeSmallGroup(keyData);
    }
}

// 전역 메서드 처리
window.subscribeSmallGroup = subscribeSmallGroup;

/**
 * 스몰 그룹 바인드 키 정보와 구독 해제 요청을 WebView앱에 전달합니다.
 * 
 * @since 2025-12-30.
 */
function unsubscribeSmallGroup(bindKeyArr) {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.unsubscribeSmallGroup) {
        const keyData = JSON.stringify(bindKeyArr);
        console.log("window.ProcessComm.unsubscribeSmallGroup(" + keyData + ") 호출");
        window.ProcessComm.unsubscribeSmallGroup(keyData);
    }
}

// 전역 메서드 처리
window.unsubscribeSmallGroup = unsubscribeSmallGroup;

/**
 * 믹스드 클래스용 임시 바인드 키 정보와 구독 요청을 WebView앱에 전달합니다.
 * 
 * @param {String} bindKey - 임시 바인드 키
 * @since 2025-12-30.
 */
function subscribeTempKey(bindKey) {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.subscribeTempKey) {
        console.log("window.ProcessComm.subscribeTempKey(" + bindKey + ") 호출");
        window.ProcessComm.subscribeTempKey(bindKey);
        console.log("믹스드 클래스 임시 바인드 키 구독 요청 전송");
    }
}

// 전역 메서드 처리
window.subscribeTempKey = subscribeTempKey;

/**
 * 믹스드 클래스용 임시 바인드 키 정보와 구독 해제 요청을 WebView앱에 전달합니다.
 * 
 * @param {String} bindKey - 임시 바인드 키
 * @param {String} userSeq - 사용자 번호
 * @param {String} liveSeq - 클래스 번호
 * @param {String} teacherSeq - 선생님 사용자 번호
 * @param {String} chatRoomSeq - 선생님 팀업 번호
 * @since 2025-12-30.
 */
function unsubscribeTempKey(bindKey, userSeq, liveSeq, teacherSeq, chatRoomSeq) {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.unsubscribeTempKey) {
        console.log("window.ProcessComm.unsubscribeTempKey(bindKey: " + bindKey
            + ", userSeq: " + userSeq + ", liveSeq: ", liveSeq, ", teacherSeq: " + teacherSeq
            + ", chatRoomSeq: " + chatRoomSeq + ")");
        window.ProcessComm.unsubscribeTempKey(bindKey, userSeq, liveSeq, teacherSeq, chatRoomSeq);
        console.log("믹스드 클래스 임시 바인드 키 구독 해제 요청 전송");
    }
}

// 전역 메서드 처리
window.unsubscribeTempKey = unsubscribeTempKey;

/**
 * RabbitMQ로 보낼 메시지 데이터와 전송 키 정보를 WebView앱에 전달합니다.
 * 
 * @param {String} routingKey - 메시지를 전송할 키
 * @param {String} base64Data - base64 형식의 메시지 데이터
 * @since 2025-12-31.
 */
function sendRabbit(routingKey, base64Data) {
    if (!isPentalkAndr()) {
        return;
    }

    if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.sendRabbit) {
        // console.log("window.ProcessComm.sendRabbit(", routingKey, ", base64Data) 호출");
        window.ProcessComm.sendRabbit(routingKey, base64Data);
    }
}

// 전역 메서드 처리
window.sendRabbit = sendRabbit;

// ========================================
// 파일 다운로드
// ========================================

/**
 * 안드로이드 웹뷰에 파일 다운로드를 요청한다.
 * 
 * @param {String} url - 파일 다운로드 URL
 * @param {String} [originalFileName=null] - 업로드된 파일의 원본 파일 이름 (기본값: null)
 * @param {String} [isOverwriteAllowed=true] - 기존 파일 덮어쓰기를 허용할지 여부 (기본값: true)
 * @param {Boolean} [executeYn="N"] - 파일을 실행할지 여부 (기본값: "N")
 * @param {Object} [contentInfo=null] - 컨텐츠 정보 (contentInfo: { contentSeq, contentTeacherSeq, refContentSeq, userSeq })
 * @since 2026-02-09.
 * @updated 2026-06-09.
 */
function fileDownload(url, originalFileName = null, isOverwriteAllowed = true, executeYn = "N", contentInfo = null) {
    // Android WebView에서 다운로드
    if (typeof window.ProcessComm !== "undefined") {
        if (window.ProcessComm.downloadFileWithContentInfo) {
            console.log(`window.ProcessComm.downloadFileWithContentInfo(url: ${url}, originalFileName: ${originalFileName}, isOverwriteAllowed: ${isOverwriteAllowed}, executeYn: ${executeYn}, contentInfo: ${contentInfo ? JSON.stringify(contentInfo) : null}) 호출`);
            window.ProcessComm.downloadFileWithContentInfo(url, originalFileName, isOverwriteAllowed, executeYn, contentInfo);
        } else if (window.ProcessComm.downloadFile) {
            console.log(`window.ProcessComm.downloadFile(url: ${url}, originalFileName: ${originalFileName}, isOverwriteAllowed: ${isOverwriteAllowed}) 호출`);
            window.ProcessComm.downloadFile(url, originalFileName, isOverwriteAllowed);
        }
    } else {
        // 일반 브라우저에서는 window.open 사용
        window.open(url, '_blank');
    }
}

// 전역 메서드 처리
window.fileDownload = fileDownload;

// ========================================
// 기타
// ========================================

/**
 * ★ 학생 클라이언트 로그인 성공 시 호출하는 함수
 * 
 * 동작:
 * 1. window.ProcessComm.hideBookmarkButtonArea() 호출
 * 2. 즐겨찾기 버튼 영역 숨김
 * 3. WebView 확장
 * 4. 350ms 후 레이아웃 재계산
 * 
 * @since 2025-12-03.
 * @updated 2026-01-05. Canvas 크기 조정 문제 해결을 위한 resize 이벤트 추가
 */
function onStudentLoginSuccess() {
    if (!isPentalkAndr()) {
        return;
    }

    console.log("========================================");
    console.log("Pro 버전: 학생 로그인 성공");
    console.log("========================================");
    console.log("즐겨찾기 버튼 영역 숨김 요청 (WebView 확장)");

    try {
        // ProcessComm 인터페이스 사용 가능 여부 확인
        if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.hideBookmarkButtonArea) {
            console.log("✅ window.ProcessComm.hideBookmarkButtonArea() 호출");
            window.ProcessComm.hideBookmarkButtonArea();

            // 애니메이션 완료 후 레이아웃 재계산
            setTimeout(() => {
                recalculateWebPageLayout();
                console.log("✅ 로그인 성공 - WebView 확장 완료");
                
                // ★ Canvas 크기 재조정을 위해 window resize 이벤트 발생 ★
                // LiveDrawingCanvas의 resize 이벤트 리스너가 onChangeCanvasSize를 호출하도록 함
                // LiveDrawingCanvas.js 라인 188: window.addEventListener('resize', onChangeCanvasSize);
                setTimeout(() => {
                    window.dispatchEvent(new Event('resize'));
                    console.log("✅ Canvas 크기 재조정을 위한 resize 이벤트 발생");
                }, 100); // 레이아웃 재계산 완료 후 추가 시간 확보
            }, 350); // 애니메이션 시간 대기
        }
    } catch (error) {
        console.error("❌ ProcessComm 인터페이스 - 로그인 성공 처리 중 오류:", error);
    }

    console.log("========================================");
}

// 전역 메서드 처리
window.onStudentLoginSuccess = onStudentLoginSuccess;

/**
 * ★ 학생 클라이언트 로그인 실패 시 호출하는 함수
 *
 * 동작:
 * 1. 로그인 실패 코드와 메시지 확인
 * 2. window.ProcessComm.onStudentLoginFailed() 호출
 * 3. 구형 Android 앱에서는 기존 웹 로그인 오류 UI 유지
 *
 * @param {string} errorCode 로그인 실패 코드
 * @param {string} message 로그인 실패 메시지
 * @since 2026-08-13.
 * @updated 2026-08-20. 로그인 준비·인증·클래스 입장 실패 결과 전달 경로 보강
 */
function onStudentLoginFailed(errorCode, message) {
    if (!isPentalkAndr()) {
        return;
    }

    console.log("========================================");
    console.log("Pro 버전: 학생 로그인 실패");
    console.log(`errorCode[${errorCode}], message[${message}]`);
    console.log("========================================");

    try {
        // 20260820 구형 Android 앱에서도 기존 로그인 오류 UI가 유지되도록 메서드 존재 여부를 확인한다.
        if (typeof window.ProcessComm !== "undefined" && typeof window.ProcessComm.onStudentLoginFailed === "function") {
            console.log("✅ window.ProcessComm.onStudentLoginFailed() 호출");
            window.ProcessComm.onStudentLoginFailed(errorCode || "LOGIN_REJECTED", message || "");
        } else {
            console.log("window.ProcessComm.onStudentLoginFailed is undefined");
        }
    } catch (error) {
        console.error("❌ ProcessComm 인터페이스 - 로그인 실패 처리 중 오류:", error);
    }
}

window.onStudentLoginFailed = onStudentLoginFailed;

/**
 * ★ [나가기] 버튼 클릭 시 호출하는 함수
 * 
 * 동작:
 * 1. window.ProcessComm.exit() 호출
 * 2. 즐겨찾기 버튼 영역 표시
 * 3. WebView 축소
 * 4. 350ms 후 레이아웃 재계산
 * 
 * @since 2025-12-03.
 */
function onExitButtonClick() {
    // 260812 학생 앱(Windows Pentalk Browser / Android AndWebnote2606)에 수업 퇴장을 알린다.
    // 260918 Android 학생 앱에도 나가도록 sendToStudentApp()으로 바꿨다 — 지우지 말 것.
    // 앱이 이 신호를 못 받으면 계속 "수업 중"으로 알고 있어 다음 자동 로그인에서
    // 그 학생만 조용히 빠진다. 오류도 로그도 남지 않는다.
    // 계약: PentalkAgent\docs\external\web-to-student-app-disconnect-contract.md §3-3
    // 요청: PentalkAgentAndroid\docs\external\web-frontend-android-bridge-request-20260918.md §5
    // 아래 isPentalkAndr() 가드보다 앞에 있어야 한다 — Windows도 AndWebnote2606도
    // window.ProcessComm이 없어 거기서 return된다.
    console.log("call sendToStudentApp({ kind: 'disconnect', reason: 'user-exit' }).");
    sendToStudentApp({ kind: "disconnect", reason: "user-exit" });

    if (!isPentalkAndr()) {
        return;
    }

    console.log("========================================");
    console.log("Pro 버전: [나가기] 버튼 클릭");
    console.log("========================================");
    console.log("즐겨찾기 버튼 영역 표시 요청 (WebView 축소)");

    try {
        // ProcessComm 인터페이스 사용 가능 여부 확인
        if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.exit) {
            console.log("✅ window.ProcessComm.exit() 호출");
            window.ProcessComm.exit();

            // 애니메이션 완료 후 레이아웃 재계산
            setTimeout(() => {
                recalculateWebPageLayout();
                console.log("✅ 나가기 완료 - 즐겨찾기 버튼 표시됨");
            }, 350); // 애니메이션 시간 대기
        }
    } catch (error) {
        console.error("❌ ProcessComm 인터페이스 - 나가기 처리 중 오류:", error);
    }

    console.log("========================================");
}

// 전역 메서드 처리
window.onExitButtonClick = onExitButtonClick;

/**
 * ★ 즐겨찾기 버튼 영역을 직접 표시하는 함수
 * 
 * 동작:
 * 1. window.ProcessComm.showBookmarkButtonArea() 호출
 * 2. 즐겨찾기 버튼 영역 표시
 * 3. WebView 축소
 * 4. 350ms 후 레이아웃 재계산
 * 
 * @since 2025-12-03.
 */
function showBookmarkButtonArea() {
    if (!isPentalkAndr()) {
        return;
    }

    console.log("========================================");
    console.log("Pro 버전: 즐겨찾기 버튼 영역 직접 표시");
    console.log("========================================");

    try {
        // ProcessComm 인터페이스 사용 가능 여부 확인
        if (typeof window.ProcessComm !== "undefined" && window.ProcessComm.showBookmarkButtonArea) {
            console.log("✅ window.ProcessComm.showBookmarkButtonArea() 호출");
            window.ProcessComm.showBookmarkButtonArea();

            // 애니메이션 완료 후 레이아웃 재계산
            setTimeout(() => {
                recalculateWebPageLayout();
                console.log("✅ 즐겨찾기 버튼 영역 표시 완료");
            }, 350); // 애니메이션 시간 대기
        }
    } catch (error) {
        console.error("❌ ProcessComm 인터페이스 - 즐겨찾기 버튼 표시 처리 중 오류:", error);
    }

    console.log("========================================");
}

// 전역 메서드 처리
window.showBookmarkButtonArea = showBookmarkButtonArea;

// ============================================================
// ★ WebView 레이아웃 재계산 함수들
// ============================================================

/**
 * ★ 웹 페이지 레이아웃을 재계산하는 메인 함수.
 * 버튼 영역의 표시/숨김 후 웹 화면의 높이와 레이아웃을 다시 계산합니다.
 * 
 * @since 2025-12-03.
 */
function recalculateWebPageLayout() {
    if (!isPentalkAndr()) {
        return;
    }

    console.log("========================================");
    console.log("Pro 버전: WebView 레이아웃 재계산 시작");
    console.log("========================================");

    try {
        // 1. 현재 뷰포트 크기 정보 수집
        const viewportInfo = getViewportInfo();
        console.log("현재 뷰포트:", viewportInfo.windowWidth + "x" + viewportInfo.windowHeight);

        // 2. 웹 페이지 컨테이너 요소들 재조정
        adjustWebPageContainers(viewportInfo);

        // 3. Canvas 요소들 크기 재조정
        resizeCanvasElements(viewportInfo);

        // 4. 미디어 요소들 크기 재조정
        resizeMediaElements(viewportInfo);

        // 5. 스크롤 영역 재계산
        recalculateScrollAreas(viewportInfo);

        // 6. CSS 커스텀 속성 업데이트
        updateCSSCustomProperties(viewportInfo);

        // 7. 브라우저 리플로우 강제 실행
        forceReflow();

        // 8. 커스텀 이벤트 발생
        const customResizeEvent = new CustomEvent("pentalk-layout-recalculated", {
            detail: viewportInfo
        });
        window.dispatchEvent(customResizeEvent);

        console.log("✅ WebView 레이아웃 재계산 완료");
    } catch (error) {
        console.error("❌ Android WebView 레이아웃 재계산 중 오류:", error);
    }

    console.log("========================================");
}

/**
 * ★ 현재 뷰포트 정보를 수집하는 함수.
 * 
 * @returns {Object} 뷰포트 정보 객체
 * @since 2025-12-03.
 */
function getViewportInfo() {
    return {
        windowWidth: window.innerWidth,
        windowHeight: window.innerHeight,
        documentWidth: document.documentElement.clientWidth,
        documentHeight: document.documentElement.clientHeight,
        visualViewportWidth: window.visualViewport ? window.visualViewport.width : window.innerWidth,
        visualViewportHeight: window.visualViewport ? window.visualViewport.height : window.innerHeight,
        screenWidth: window.screen.width,
        screenHeight: window.screen.height,
        devicePixelRatio: window.devicePixelRatio || 1,
        scrollX: window.pageXOffset || document.documentElement.scrollLeft,
        scrollY: window.pageYOffset || document.documentElement.scrollTop
    };
}

/**
 * ★ 웹 페이지의 주요 컨테이너 요소들을 재조정하는 함수.
 * 
 * @param {Object} viewportInfo 뷰포트 정보
 * @since 2025-12-03.
 */
function adjustWebPageContainers(viewportInfo) {
    if (!isPentalkAndr()) {
        return;
    }

    console.log("컨테이너 요소들 재조정");

    const containerSelectors = [
        'body',
        '#mainDiv',
        '.main-area',
        '.full-area',
        '.pencam-entire-area',
        '.login-area',
        '#contentDiv'
    ];

    containerSelectors.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(element => {
            const computedStyle = getComputedStyle(element);

            if (computedStyle.height.includes('100vh') || element.style.height === '100vh') {
                element.style.height = viewportInfo.windowHeight + 'px';
                element.style.minHeight = viewportInfo.windowHeight + 'px';
            }

            if (computedStyle.width === '100vw' || element.style.width === '100vw') {
                element.style.width = viewportInfo.windowWidth + 'px';
            }
        });
    });
}

/**
 * ★ Canvas 요소들의 크기를 재조정하는 함수.
 * 
 * @param {Object} viewportInfo 뷰포트 정보
 * @since 2025-12-03.
 */
function resizeCanvasElements(viewportInfo) {
    if (!isPentalkAndr()) {
        return;
    }

    console.log("Canvas 요소들 크기 재조정");

    setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
        console.log("✅ Canvas 크기 재조정을 위한 resize 이벤트 발생");
    }, 100); // 레이아웃 재계산 완료 후 추가 시간 확보

    // Canvas 영역 크기 조정
    const canvasArea = document.getElementById('canvas-area');
    if (canvasArea) {
        const toolbarHeight = 48;
        const canvasHeight = viewportInfo.windowHeight - toolbarHeight;
        canvasArea.style.width = '100%';
        canvasArea.style.height = canvasHeight + 'px';
    }
}

/**
 * ★ 미디어 요소들의 크기를 재조정하는 함수.
 * 
 * @param {Object} viewportInfo 뷰포트 정보
 * @since 2025-12-03.
 */
function resizeMediaElements(viewportInfo) {
    if (!isPentalkAndr()) {
        return;
    }

    console.log("미디어 요소들 크기 재조정");

    // 비디오 요소들
    const videoElements = document.querySelectorAll("video");
    videoElements.forEach(video => {
        if (video.style.width === "100%" || video.style.height === "100%") {
            video.style.maxWidth = "100%";
            video.style.maxHeight = "100%";
            video.style.objectFit = "contain";
        }
    });

    // 이미지 요소들
    const imageElements = document.querySelectorAll("img");
    imageElements.forEach(img => {
        if (img.style.width === "100vw" || img.style.height === "100vh") {
            img.style.maxWidth = viewportInfo.windowWidth + "px";
            img.style.maxHeight = viewportInfo.windowHeight + "px";
        }
    });
}

/**
 * ★ 스크롤 영역들을 재계산하는 함수.
 * 
 * @param {Object} viewportInfo 뷰포트 정보
 * @since 2025-12-03.
 */
function recalculateScrollAreas(viewportInfo) {
    if (!isPentalkAndr()) {
        return;
    }

    console.log("스크롤 영역들 재계산");

    const scrollableSelectors = [
        '.scrollable',
        '.scroll-container',
        '#mainDiv',
        '[style*="overflow"]'
    ];

    scrollableSelectors.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(element => {
            const computedStyle = getComputedStyle(element);
            if (computedStyle.overflow === 'auto' || computedStyle.overflow === 'scroll' ||
                computedStyle.overflowY === 'auto' || computedStyle.overflowY === 'scroll') {

                const rect = element.getBoundingClientRect();
                const availableHeight = viewportInfo.windowHeight - rect.top;

                if (availableHeight > 0) {
                    element.style.maxHeight = availableHeight + 'px';
                }
            }
        });
    });
}

/**
 * ★ CSS 커스텀 속성들을 업데이트하는 함수.
 * 
 * @param {Object} viewportInfo 뷰포트 정보
 * @since 2025-12-03.
 */
function updateCSSCustomProperties(viewportInfo) {
    if (!isPentalkAndr()) {
        return;
    }

    console.log("CSS 커스텀 속성 업데이트");

    const vhValue = viewportInfo.windowHeight / 100;

    document.documentElement.style.setProperty('--viewport-width', viewportInfo.windowWidth + 'px');
    document.documentElement.style.setProperty('--viewport-height', viewportInfo.windowHeight + 'px');
    document.documentElement.style.setProperty('--vh', vhValue + 'px');
    document.documentElement.style.setProperty('--webnote-viewport-width', viewportInfo.windowWidth + 'px');
    document.documentElement.style.setProperty('--webnote-viewport-height', viewportInfo.windowHeight + 'px');

    console.log("✅ --vh:", vhValue + "px");
}

/**
 * ★ 브라우저 리플로우를 강제로 실행하는 함수.
 * 
 * @since 2025-12-03.
 */
function forceReflow() {
    if (!isPentalkAndr()) {
        return;
    }

    // 강제 리플로우를 위해 레이아웃 속성 읽기
    document.body.offsetHeight;
    document.documentElement.scrollHeight;

    // 약간의 지연 후 다시 한 번
    setTimeout(() => {
        document.body.offsetWidth;
        window.getComputedStyle(document.body).height;
    }, 10);
}

/**
 * ★ 뷰포트 변화 감지 및 자동 재계산 설정.
 * 
 * @since 2025-12-03.
 */
function setUpViewportChangeDetection() {
    if (!isPentalkAndr()) {
        return;
    }

    console.log("========================================");
    console.log("Pro 버전: 뷰포트 변화 감지 설정");
    console.log("========================================");

    let resizeTimeout;
    let isRecalculatingLayout = false;

    // 윈도우 리사이즈 이벤트
    window.addEventListener("resize", function (event) {
        if (isRecalculatingLayout || event.detail === "pentalk-recalculation") {
            return;
        }

        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            console.log("윈도우 리사이즈 감지");
            isRecalculatingLayout = true;
            recalculateWebPageLayout();

            setTimeout(() => {
                isRecalculatingLayout = false;
            }, 100);
        }, 250);
    });

    // 방향 변경 이벤트
    window.addEventListener("orientationchange", function () {
        setTimeout(() => {
            console.log("디바이스 방향 변경 감지");
            if (!isRecalculatingLayout) {
                isRecalculatingLayout = true;
                recalculateWebPageLayout();

                setTimeout(() => {
                    isRecalculatingLayout = false;
                }, 100);
            }
        }, 500);
    });

    // Visual Viewport API
    if (window.visualViewport) {
        window.visualViewport.addEventListener("resize", function () {
            if (!isRecalculatingLayout) {
                console.log("Visual Viewport 변경 감지");
                isRecalculatingLayout = true;
                recalculateWebPageLayout();

                setTimeout(() => {
                    isRecalculatingLayout = false;
                }, 100);
            }
        });
    }

    console.log("✅ 뷰포트 변화 감지 설정 완료");
    console.log("========================================");
}

// ============================================================
// ★ 페이지 로드 완료 후 초기화
// ============================================================

/**
 * ★ 페이지 로드 완료 후 초기화 함수
 * 
 * @since 2025-12-03
 */
function initializeProVersion() {
    if (!isPentalkAndr()) {
        return;
    }

    console.log("========================================");
    console.log("Pentalk Capture Pro 버전 초기화 시작");
    console.log("========================================");
    console.log("✅ ProcessComm 인터페이스 사용");
    console.log("========================================");

    // ProcessComm 인터페이스 사용 가능 여부 확인
    if (typeof window.ProcessComm !== "undefined") {
        console.log("✅ ProcessComm 인터페이스 사용 가능");
    } else {
        console.log("❌ ProcessComm 인터페이스를 사용할 수 없습니다");
    }

    // 뷰포트 변화 감지 설정
    setUpViewportChangeDetection();

    // [나가기] 버튼 이벤트 리스너 설정 (선택사항)
    // setUpExitButtonListener();

    // 로그인 상태 감시 Observer 설정 (선택사항)
    // setUpLoginStatusObserver();

    console.log("✅ Pentalk Capture Pro 버전 초기화 완료");
    console.log("========================================");
}

if (isPentalkAndr()) {
    // ★ 페이지 로드 시 자동 초기화
    if (document.readyState === "loading") {
        console.log("Pro 버전: DOMContentLoaded 이벤트 대기");
        document.addEventListener("DOMContentLoaded", initializeProVersion);
    } else {
        console.log("Pro 버전: 문서 이미 로드됨 - 즉시 초기화");
        initializeProVersion();
    }
}
